import request from '@/utils/request'

// 梯联网大数据看板
export function getBoardData() {
  return request({
    url: '/elevatorHome/homeBoard',
    method: 'get'
  })
}

// 管理平台-数据中心
export function getDataCenter() {
  return request({
    url: '/elevatorHome/getElevatorIotAdmin',
    method: 'get'
  })
}

// 管理平台-电梯智慧云监控
export function getSmartYun() {
  return request({
    url: '/elevatorHome/elevatorHomeVideo',
    method: 'get'
  })
}

// 管理平台-监控中心
export function monitiorCenter() {
  return request({
    url: '/elevatorHome/MonitoringCenterDetailVo',
    method: 'get'
  })
}

// 管理平台-地图
export function getMapData(params) {
  return request({
    url: '/elevatorHome/mapList',
    method: 'get',
    params
  })
}